export const DATA_INITED = 'dataInited'
export const DATA_INITED_2 = 'dataInited2'
